import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {TableReportData} from "./table-report.data";

@Injectable()
export class TableReportModel extends ReportModel<TableReportData> {
    constructor(injector: Injector) {
        super(injector, TableReportData);
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
